import type { ClipPlaneCreateEventData } from '@ui/events'

export type ClipPlanePreset = 'xz' | 'xy' | 'yz'

/** Matches ClipController PLANE_SIZE / 2 */
export const CLIP_PLANE_PREVIEW_HALF_SIZE = 20

export const PRESET_CLIP_PLANES: Record<
  ClipPlanePreset,
  Pick<ClipPlaneCreateEventData, 'normal' | 'point'>
> = {
  xz: {
    normal: { x: 0, y: 0, z: 1 },
    point: { x: 0, y: 0, z: 0.5 },
  },
  xy: {
    normal: { x: 0, y: 1, z: 0 },
    point: { x: 0, y: 0.5, z: 0 },
  },
  yz: {
    normal: { x: 1, y: 0, z: 0 },
    point: { x: 0.5, y: 0, z: 0 },
  },
}

type Point3 = { x: number; y: number; z: number }

export const getHorizontalClipPlaneOutlinePoints = (point: Point3) => {
  const halfSize = CLIP_PLANE_PREVIEW_HALF_SIZE

  return [
    { x: point.x - halfSize, y: point.y - halfSize, z: point.z },
    { x: point.x + halfSize, y: point.y - halfSize, z: point.z },
    { x: point.x + halfSize, y: point.y + halfSize, z: point.z },
    { x: point.x - halfSize, y: point.y + halfSize, z: point.z },
  ]
}

export const IMPORT_HELPER_CLIP_PLANES = [
  { point: { x: 0, y: 0, z: 1.5 } },
  { point: { x: 0, y: 0, z: 2.5 } },
] as const

export const getPresetClipPlaneOutlinePoints = (preset: ClipPlanePreset) => {
  const { point } = PRESET_CLIP_PLANES[preset]
  const halfSize = CLIP_PLANE_PREVIEW_HALF_SIZE

  switch (preset) {
    case 'xz':
      return getHorizontalClipPlaneOutlinePoints(point)
    case 'xy':
      return [
        { x: point.x - halfSize, y: point.y, z: point.z - halfSize },
        { x: point.x + halfSize, y: point.y, z: point.z - halfSize },
        { x: point.x + halfSize, y: point.y, z: point.z + halfSize },
        { x: point.x - halfSize, y: point.y, z: point.z + halfSize },
      ]
    case 'yz':
      return [
        { x: point.x, y: point.y - halfSize, z: point.z - halfSize },
        { x: point.x, y: point.y + halfSize, z: point.z - halfSize },
        { x: point.x, y: point.y + halfSize, z: point.z + halfSize },
        { x: point.x, y: point.y - halfSize, z: point.z + halfSize },
      ]
  }
}

export type ClipPlaneHoverPreview = ClipPlanePreset | 'import-helper'
